import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('[ErrorBoundary] Application crashed:', error, errorInfo);
    // Mettre à jour le statut de boot s'il existe encore
    if (typeof window !== 'undefined' && window.__BOOT_STATUS__) {
      window.__BOOT_STATUS__('ERREUR: ' + (error?.message || 'Application crashée'));
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#0B1F3A',
          color: '#F59E0B',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20,
          fontFamily: 'system-ui, -apple-system, sans-serif',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: 48, marginBottom: 20 }}>⚠️</div>
          <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
            Erreur au démarrage
          </div>
          <div style={{ fontSize: 14, color: '#94A3B8', marginBottom: 20, maxWidth: 500 }}>
            {this.state.error?.message || 'Une erreur inattendue est survenue'}
          </div>
          <details style={{ color: '#64748B', fontSize: 12, maxWidth: 500, textAlign: 'left' }}>
            <summary style={{ cursor: 'pointer', marginBottom: 8 }}>Détails techniques</summary>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {this.state.error?.stack || 'Pas de stack trace'}
              {'\n\n'}
              {this.state.errorInfo?.componentStack || ''}
            </pre>
          </details>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: 24,
              padding: '12px 24px',
              background: '#F59E0B',
              color: '#0B1F3A',
              border: 'none',
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Recharger l&apos;application
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
